import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) { }

  getAllRoles() {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secroles`);
  }

  getRoleById(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secroles/${id}`);
  }

  updateRole(id: number, roleName: string, updatedBy: string, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_SEC}/api/secroles/${id}`, { id, roleName, updatedBy, active });
  }

  getRolePermissions(rodeId: number) {
    return this.http.get<any>(
      `${environment.API_URL_SEC}/api/secoptionsbyrole/${rodeId}`);
  }
  getAllPermissions() {
    return this.http.get<any>(
      `${environment.API_URL}/api/sysfunctionoptions`);
  }

  deleteUserRoleOption(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_SEC}/api/secrolesoptions/${id}`);
  }

  addUserRoleOption(roleid: number, productid: number, moduleid: number, menuid: number, functionid: number, optionid: number, optionValue: string) {
    return this.http.post<any>(
      `${environment.API_URL_SEC}/api/secroleoption`, {
      roleid, productid, moduleid, menuid, functionid, optionid, optionValue
    });
  }

  deleteUserRoleOptionByRoleId(roleId: number) {
    return this.http.delete<any>(
      `${environment.API_URL_SEC}/api/secdeleteoptionsbyrole/${roleId}`);
  }
}
